import { ConfigStateService, LocalizationService } from '@abp/ng.core';
import { ToasterService } from '@abp/ng.theme.shared';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { map } from 'rxjs';
import { ConfigurationSettingsDto } from 'src/core/models/configuration-setting/configuration-settings.dto';
import { FileCompressionAudioFormat } from 'src/core/models/generic-lookup-type/conversation/filecompression-audioformat.glt';
import { FileCompressionBitrate } from 'src/core/models/generic-lookup-type/conversation/filecompression-bitrate.glt';
import { GenericLookupDto } from 'src/core/models/generic-lookup/generic-lookup.dto';
import { ConfigurationSettingsService } from 'src/core/services/configuration-settings/configuration-settings.service';
import { GenericLookupTypeService } from 'src/core/services/generic-lookup-type/generic-lookup-type.service';
import { GenericLookupTypeState } from 'src/core/states/generic-lookup-type/generic-lookup-type.state';

@Component({
  selector: 'ca-file-compression-settings',
  templateUrl: './file-compression-settings.component.html',
  styleUrl: './file-compression-settings.component.scss',
  standalone: false,
})
export class FileCompressionSettingsComponent implements OnInit {
  form: FormGroup;

  fileCompressionBitrates: GenericLookupDto[];
  availableFileCompressionBitrates: GenericLookupDto[];
  fileCompressionAudioFormats: GenericLookupDto[];

  private stereoGenericLookup: GenericLookupDto;
  private bitrate8kGenericLookup: GenericLookupDto;
  private bitrate12kGenericLookup: GenericLookupDto;

  private readonly fileCompressionPrefix = 'FileCompression';
  private readonly fileCompressionBitrateSetting = `${this.fileCompressionPrefix}.Bitrate`;
  private readonly fileCompressionAudioFormatSetting = `${this.fileCompressionPrefix}.AudioFormat`;

  constructor(
    private config: ConfigStateService,
    private fb: FormBuilder,
    private store: Store,
    private settingService: ConfigurationSettingsService,
    private toastr: ToasterService,
    private localizationService: LocalizationService,
    private genericLookupTypeService: GenericLookupTypeService
  ) {
    this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(FileCompressionBitrate)))
      .subscribe(result => {
        this.fileCompressionBitrates = result;
        this.availableFileCompressionBitrates = [...result];
      });

    this.store
      .select(GenericLookupTypeState.getGenericLookups)
      .pipe(map(filterFn => filterFn(FileCompressionAudioFormat)))
      .subscribe(result => {
        this.fileCompressionAudioFormats = result;
      });

    this.stereoGenericLookup = this.genericLookupTypeService.findGenericLookupWithId(
      FileCompressionAudioFormat.stereo
    );
    this.bitrate8kGenericLookup = this.genericLookupTypeService.findGenericLookupWithId(
      FileCompressionBitrate.bitrate8k
    );
    this.bitrate12kGenericLookup = this.genericLookupTypeService.findGenericLookupWithId(
      FileCompressionBitrate.bitrate12k
    );
    let fileCompressionBitrate = this.config.getSetting(this.fileCompressionBitrateSetting);
    let fileCompressionAudioFormat = this.config.getSetting(this.fileCompressionAudioFormatSetting);

    this.form = fb.group({
      fileCompressionBitrate: fileCompressionBitrate,
      fileCompressionAudioFormat: null,
    });

    this.form.get('fileCompressionAudioFormat').valueChanges.subscribe(value => {
      if (value == this.stereoGenericLookup.code) {
        this.availableFileCompressionBitrates = [
          ...this.fileCompressionBitrates.filter(
            item =>
              item.code != this.bitrate8kGenericLookup.code &&
              item.code != this.bitrate12kGenericLookup.code
          ),
        ];
        var firstItem = this.availableFileCompressionBitrates[0];
        if (firstItem) {
          this.form.get('fileCompressionBitrate').patchValue(firstItem.code);
        }
      } else {
        this.availableFileCompressionBitrates = [...this.fileCompressionBitrates];
      }
    });

    this.form.get('fileCompressionAudioFormat').patchValue(fileCompressionAudioFormat);
  }

  ngOnInit(): void {}

  onSubmitForm() {
    if (this.form.invalid) {
      return;
    }

    const settings: ConfigurationSettingsDto[] = [];

    settings.push({
      settingName: this.fileCompressionBitrateSetting,
      settingValue: this.form.get('fileCompressionBitrate').value.toString(),
    });

    settings.push({
      settingName: this.fileCompressionAudioFormatSetting,
      settingValue: this.form.get('fileCompressionAudioFormat').value.toString(),
    });

    this.settingService.saveSetting(settings).subscribe(res => {
      this.toastr.success(
        this.localizationService.instant('AbpSettingManagement::SavedSuccessfully')
      );
    });
  }
}
